<template>
  <BaseFilterDialogAndChips
    :submitted-values="submittedValues"
    :show-reset-button="showResetButton"
    @open="copyFilterParams"
    @clear:filter="clearFilter"
    @reset="resetFilters"
    @submit="submitFilters"
  >
    <v-row dense>
      <v-col cols="12" sm="6">
        <ContactAutocomplete
          v-model="params.supplier_id"
          suppliers-only
          @update:initial-item="updateAutocompleteValue('client_id', $event)"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-textarea
          v-model="params.description"
          :label="$t('general.description')"
          rows="1"
          auto-grow
        />
      </v-col>

      <v-col cols="12" sm="6">
        <BaseDatepickerInput
          v-model="params.document_date_from"
          :label="$t('filters.document_date_from')"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <BaseDatepickerInput
          v-model="params.document_date_to"
          :label="$t('filters.document_date_to')"
        />
      </v-col>
    </v-row>
  </BaseFilterDialogAndChips>
</template>

<script>
import BaseFilterDialogAndChips from '@/components/base/BaseFilterDialogAndChips';
import BaseDatepickerInput from '@/components/base/BaseDatepickerInput';
import ContactAutocomplete from '@/components/autocompletes/ContactAutocomplete';
import filterMixin from '@/mixins/filter-mixin';
import { getDefaultReceivedInvoiceFilterParams } from '@/store/modules/received-invoices-module';

export default {
  name: 'ReceivedInvoiceFilter',

  components: { ContactAutocomplete, BaseDatepickerInput, BaseFilterDialogAndChips },

  mixins: [filterMixin],

  data() {
    return {
      defaultParams: getDefaultReceivedInvoiceFilterParams(),
    };
  },

  computed: {
    submittedValues() {
      const values = [];
      const { supplier_id, description, document_date_from, document_date_to } = this.filterParams;

      if (supplier_id && this.autocompleteValues.supplier_id?.id === supplier_id) {
        values.push({
          key: 'supplier_id',
          value: this.autocompleteValues.supplier_id.name,
          label: this.$t('general.contact'),
        });
      }

      if (description) {
        values.push({
          key: 'description',
          value: description,
          label: this.$t('general.description'),
        });
      }

      if (document_date_from) {
        values.push({
          key: 'document_date_from',
          value: document_date_from,
          label: this.$t('filters.document_date_from'),
        });
      }

      if (document_date_to) {
        values.push({
          key: 'document_date_to',
          value: document_date_to,
          label: this.$t('filters.document_date_to'),
        });
      }

      return values;
    },
  },
};
</script>

<style scoped></style>
